import MUIModal from "../../../shared/MUIModal";
import SABox from "../../../shared/SABox";
import SAButton from "../../../shared/SAButton";
import SAStack from "../../../shared/SAStack";
import SATypography from "../../../shared/SATypography";

const StartInspectionModal = ({
  open,
  onClose,
  onConfirm,
  t,
  loading,
  text,
}) => (
  <MUIModal
    open={open}
    maxWidth="xs"
    handleClose={onClose}
    content={
      <SABox p={2}>
        <SATypography
          mb={2}
          fontWeight={500}
          fontSize={18}
          color="text.primary"
          sx={{ textAlign: "center" }}
        >
          {text}
        </SATypography>
        <SAStack direction="row" gap={2} justifyContent="center">
          <SAButton onClick={onClose} color="inherit" disabled={loading}>
            {t("cancel")}
          </SAButton>
          <SAButton
            variant="contained"
            color="primary"
            onClick={onConfirm}
            disabled={loading}
            loading={loading}
          >
            {t("confirm")}
          </SAButton>
        </SAStack>
      </SABox>
    }
  />
);

export default StartInspectionModal;
